import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionOneTitleTextsBody,
    SectionOneTitleTextsDetails,
} from "types/api/blocks/sectionOneTitleTexts";

function useSectionOneTitleTextsApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionOneTitleTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionOneTitleTextsDetails> => {
        return get<PathParamsWithId, undefined, SectionOneTitleTextsDetails>({
            url: "/blocks/section-five-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionOneTitleTexts = React.useCallback((body: SectionOneTitleTextsBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionOneTitleTextsBody, null>({
            url: "/blocks/section-five-texts",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionOneTitleTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-five-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionOneTitleTexts,
        saveSectionOneTitleTexts,
        deleteSectionOneTitleTexts
    };
}

export default useSectionOneTitleTextsApi;